<script lang="ts" setup>
import { useField } from 'vee-validate';
import { toTypedSchema } from '@vee-validate/zod';
import { z } from 'zod';
import VRadioField from '@shared/form/VRadioField/VRadioField.vue';
import FieldRowV2 from '@shared/form/FieldRowV2/FieldRowV2.vue';
import { jaNeeOptions } from '@shared/form/VRadioField/JaNeeOptions';

const { value, errors } = useField(
  'bedrijfseigenaar',
  toTypedSchema(
    z.boolean().refine((v) => !v, {
      message: `Deze wijziging is niet mogelijk. In geval van een nieuwe eigenaar dient een nieuwe aanvraag onder een nieuwe relatie te worden ingediend. De actieve polissen onder deze relatie kunnen worden beëindigd.`,
    }),
  ),
);
</script>

<template>
  <FieldRowV2
    required
    label="Is er sprake van een andere of extra bedrijfseigenaar?"
    label-for="bedrijfseigenaar"
    :errors="errors"
    v-bind="$attrs"
  >
    <VRadioField v-model:value="value" name="bedrijfseigenaar" :options="jaNeeOptions" />
  </FieldRowV2>
</template>
